<template>
<div class="chapter">
<div class="inner_page">
<div class="contents" id="con">
<h2 class="contentsHead">Contents</h2>
<div class="contentsEntry">
<p class="contentsEntryName" id="ded_01"><span href="#/plainclothesnaked_ded01#ded01" title="Link target outside of Sample">Dedication</span></p>
</div>
<div class="contentsEntry" id="epi_01">
<p class="contentsEntryName"><span href="#/plainclothesnaked_epi01#epi01" title="Link target outside of Sample">Epigraph</span></p>
</div>
<div class="contentsEntry1b" id="fm_01">
<p class="contentsEntryName"><a href="#/plainclothesnaked_fm01#fm01">Prologue</a></p>
</div>
<div class="contentsEntry" id="ch_01">
<p class="contentsEntryNumber"><a href="#/plainclothesnaked_ch01#ch01">One</a></p>
</div>
<div class="contentsEntry" id="ch_02">
<p class="contentsEntryNumber"><a href="#/plainclothesnaked_ch02#ch02">Two</a></p>
</div>
<div class="contentsEntry" id="ch_03">
<p class="contentsEntryNumber"><a href="#/plainclothesnaked_ch03#ch03">Three</a></p>
</div>
<div class="contentsEntry" id="ch_04">
<p class="contentsEntryNumber"><a href="#/plainclothesnaked_ch04#ch04">Four</a></p>
</div>
<div class="contentsEntry" id="ch_05">
<p class="contentsEntryNumber"><a href="#/plainclothesnaked_ch05#ch05">Five</a></p>
</div>
<div class="contentsEntry" id="ch_06">
<p class="contentsEntryNumber"><a href="#/plainclothesnaked_ch06#ch06">Six</a></p>
</div>
<div class="contentsEntry" id="ch_07">
<p class="contentsEntryNumber"><span href="#/plainclothesnaked_ch07#ch07" title="Link target outside of Sample">Seven</span></p>
</div>
<div class="contentsEntry" id="ch_08">
<p class="contentsEntryNumber"><span href="#/plainclothesnaked_ch08#ch08" title="Link target outside of Sample">Eight</span></p>
</div>
<div class="contentsEntry" id="ch_09">
<p class="contentsEntryNumber"><span href="#/plainclothesnaked_ch09#ch09" title="Link target outside of Sample">Nine</span></p>
</div>
<div class="contentsEntry" id="ch_10">
<p class="contentsEntryNumber"><span href="#/plainclothesnaked_ch10#ch10" title="Link target outside of Sample">Ten</span></p>
</div>
<div class="contentsEntry" id="ch_11">
<p class="contentsEntryNumber"><span href="#/plainclothesnaked_ch11#ch11" title="Link target outside of Sample">Eleven</span></p>
</div>
<div class="contentsEntry" id="ch_12">
<p class="contentsEntryNumber"><span href="#/plainclothesnaked_ch12#ch12" title="Link target outside of Sample">Twelve</span></p>
</div>
<div class="contentsEntry" id="ch_13">
<p class="contentsEntryNumber"><span href="#/plainclothesnaked_ch13#ch13" title="Link target outside of Sample">Thirteen</span></p>
</div>
<div class="contentsEntry" id="ch_14">
<p class="contentsEntryNumber"><span href="#/plainclothesnaked_ch14#ch14" title="Link target outside of Sample">Fourteen</span></p>
</div>
<div class="contentsEntry" id="ch_15">
<p class="contentsEntryNumber"><span href="#/plainclothesnaked_ch15#ch15" title="Link target outside of Sample">Fifteen</span></p>
</div>
<div class="contentsEntry" id="ch_16">
<p class="contentsEntryNumber"><span href="#/plainclothesnaked_ch16#ch16" title="Link target outside of Sample">Sixteen</span></p>
</div>
<div class="contentsEntry" id="ch_17">
<p class="contentsEntryNumber"><span href="#/plainclothesnaked_ch17#ch17" title="Link target outside of Sample">Seventeen</span></p>
</div>
<div class="contentsEntry" id="ch_18">
<p class="contentsEntryNumber"><span href="#/plainclothesnaked_ch18#ch18" title="Link target outside of Sample">Eighteen</span></p>
</div>
<div class="contentsEntry" id="ch_19">
<p class="contentsEntryNumber"><span href="#/plainclothesnaked_ch19#ch19" title="Link target outside of Sample">Nineteen</span></p>
</div>
<div class="contentsEntry" id="ch_20">
<p class="contentsEntryNumber"><span href="#/plainclothesnaked_ch20#ch20" title="Link target outside of Sample">Twenty</span></p>
</div>
<div class="contentsEntry" id="ch_21">
<p class="contentsEntryNumber"><span href="#/plainclothesnaked_ch21#ch21" title="Link target outside of Sample">Twenty-One</span></p>
</div>
<div class="contentsEntry" id="ch_22">
<p class="contentsEntryNumber"><span href="#/plainclothesnaked_ch22#ch22" title="Link target outside of Sample">Twenty-Two</span></p>
</div>
<div class="contentsEntry" id="ch_23">
<p class="contentsEntryNumber"><span href="#/plainclothesnaked_ch23#ch23" title="Link target outside of Sample">Twenty-Three</span></p>
</div>
<div class="contentsEntry" id="ch_24">
<p class="contentsEntryNumber"><span href="#/plainclothesnaked_ch24#ch24" title="Link target outside of Sample">Twenty-Four</span></p>
</div>
<div class="contentsEntry" id="ch_25">
<p class="contentsEntryNumber"><span href="#/plainclothesnaked_ch25#ch25" title="Link target outside of Sample">Twenty-Five</span></p>
</div>
<div class="contentsEntry" id="ch_26">
<p class="contentsEntryNumber"><span href="#/plainclothesnaked_ch26#ch26" title="Link target outside of Sample">Twenty-Six</span></p>
</div>
<div class="contentsEntry" id="ch_27">
<p class="contentsEntryNumber"><span href="#/plainclothesnaked_ch27#ch27" title="Link target outside of Sample">Twenty-Seven</span></p>
</div>
<div class="contentsEntry" id="ch_28">
<p class="contentsEntryNumber"><span href="#/plainclothesnaked_ch28#ch28" title="Link target outside of Sample">Twenty-Eight</span></p>
</div>
<div class="contentsEntry" id="ch_29">
<p class="contentsEntryNumber"><span href="#/plainclothesnaked_ch29#ch29" title="Link target outside of Sample">Twenty-Nine</span></p>
</div>
<div class="contentsEntry" id="ch_30">
<p class="contentsEntryNumber"><span href="#/plainclothesnaked_ch30#ch30" title="Link target outside of Sample">Thirty</span></p>
</div>
<div class="contentsEntry" id="ch_31">
<p class="contentsEntryNumber"><span href="#/plainclothesnaked_ch31#ch31" title="Link target outside of Sample">Thirty-One</span></p>
</div>
<div class="contentsEntry" id="ch_32">
<p class="contentsEntryNumber"><span href="#/plainclothesnaked_ch32#ch32" title="Link target outside of Sample">Thirty-Two</span></p>
</div>
<div class="contentsEntry" id="ch_33">
<p class="contentsEntryNumber"><span href="#/plainclothesnaked_ch33#ch33" title="Link target outside of Sample">Thirty-Three</span></p>
</div>
<div class="contentsEntry" id="ch_34">
<p class="contentsEntryNumber"><span href="#/plainclothesnaked_ch34#ch34" title="Link target outside of Sample">Thirty-Four</span></p>
</div>
<div class="contentsEntry" id="ch_35">
<p class="contentsEntryNumber"><span href="#/plainclothesnaked_ch35#ch35" title="Link target outside of Sample">Thirty-Five</span></p>
</div>
<div class="contentsEntry" id="ch_36">
<p class="contentsEntryNumber"><span href="#/plainclothesnaked_ch36#ch36" title="Link target outside of Sample">Thirty-Six</span></p>
</div>
<div class="contentsEntry" id="ch_37">
<p class="contentsEntryNumber"><span href="#/plainclothesnaked_ch37#ch37" title="Link target outside of Sample">Thirty-Seven</span></p>
</div>
<div class="contentsEntry" id="ch_38">
<p class="contentsEntryNumber"><span href="#/plainclothesnaked_ch38#ch38" title="Link target outside of Sample">Thirty-Eight</span></p>
</div>
<div class="contentsEntry" id="ch_39">
<p class="contentsEntryNumber"><span href="#/plainclothesnaked_ch39#ch39" title="Link target outside of Sample">Thirty-Nine</span></p>
</div>
<div class="contentsEntry" id="ch_40">
<p class="contentsEntryNumber"><span href="#/plainclothesnaked_ch40#ch40" title="Link target outside of Sample">Forty</span></p>
</div>
<div class="contentsEntry" id="ch_41">
<p class="contentsEntryNumber"><span href="#/plainclothesnaked_ch41#ch41" title="Link target outside of Sample">Forty-One</span></p>
</div>
<div class="contentsEntry" id="ch_42">
<p class="contentsEntryNumber"><span href="#/plainclothesnaked_ch42#ch42" title="Link target outside of Sample">Forty-Two</span></p>
</div>
<div class="contentsEntry" id="ch_43">
<p class="contentsEntryNumber"><span href="#/plainclothesnaked_ch43#ch43" title="Link target outside of Sample">Forty-Three</span></p>
</div>
<div class="contentsEntry" id="bm_01">
<p class="contentsEntryNumber"><span href="#/plainclothesnaked_bm01#bm01" title="Link target outside of Sample">Epilogue</span></p>
</div>
<br/>
<div class="contentsEntry" id="ext1">
<p class="contentsEntryNumber"><span href="#/plainclothesnaked_excerpfrontt#ext01" title="Link target outside of Sample">An Excerpt from <i>Happy Mutant Baby Pills</i></span></p>
</div>
<div class="contentsEntry" id="excepro_01">
<p class="contentsEntryNumber" style="text-indent:1em;"><span href="#/plainclothesnaked_excerptprologue#excepro01" title="Link target outside of Sample">Prologue</span></p>
</div>
<div class="contentsEntry" id="extp">
<p class="contentsEntryNumber" style="text-indent:1em;"><span href="#/plainclothesnaked_Excerptpraise#extpra" title="Link target outside of Sample">Praise for <i>Happy Mutant Baby Pills</i></span></p>
</div>
<br/>
<div class="contentsEntry1" id="ata_01">
<p class="contentsEntryName"><span href="#/plainclothesnaked_ata01#ata01" title="Link target outside of Sample">About the Author</span></p>
</div>
<div class="contentsEntry1" id="rev_0">
<p class="contentsEntryName"><span href="#/plainclothesnaked_rev01#rev01" title="Link target outside of Sample">Praise</span></p>
</div>
<div class="contentsEntry1" id="adc_01">
<p class="contentsEntryName"><span href="#/plainclothesnaked_adc01#adc01" title="Link target outside of Sample">Also by Jerry Stahl</span></p>
</div>
<div class="contentsEntry1" id="cpy_01">
<p class="contentsEntryName"><span href="#/plainclothesnaked_cop01#cpy01" title="Link target outside of Sample">Copyright</span></p>
</div>
<div class="contentsEntry1" id="atp_01">
<p class="contentsEntryName"><span href="#/plainclothesnaked_atp01#atp01" title="Link target outside of Sample">About the Publisher</span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// plainclothesnaked_con.vue?2367bbe4